import SectionHero from './SectionHero';
export default SectionHero;
